import type { GameState } from "../../types";

export const uiReducer = (state: GameState, action: any): GameState => {
  switch (action.type) {
    case "SET_SCREEN":
      return { ...state, screen: action.screen };

    case "SET_LOADING":
      return { ...state, isLoading: action.loading };

    case "SHOW_MODAL":
      return { ...state, showModal: action.modal };

    case "HIDE_MODAL":
      return { ...state, showModal: null };

    case "SET_HUD_HINT":
      return { ...state, hudHint: action.hint };

    case "CLEAR_HUD_HINT":
      return { ...state, hudHint: null };

    case "CLEAR_LEVEL_UP":
      return { ...state, levelUpNotification: null };

    case "CLEAR_DISCOVERY_NOTIFICATION":
      return { ...state, discoveryNotification: null };

    case "START_LATTE_ART":
      return {
        ...state,
        latteArtGame: { active: true },
      };

    case "END_LATTE_ART":
      return {
        ...state,
        latteArtGame: { active: false },
      };

    case "SHOW_TREND_TIP":
      return {
        ...state,
        trendTip: { message: action.message, active: true },
      };

    case "HIDE_TREND_TIP":
      return {
        ...state,
        trendTip: { message: "", active: false },
      };

    default:
      return state;
  }
};
